import { render } from "./candidates.vue?vue&type=template&id=32c6897c"
import script from "./candidates.vue?vue&type=script&lang=js"
export * from "./candidates.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__